module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1041.1d523379.png";